export default "__VITE_ASSET__DmKm9c6w__"